import type { IconNames } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';

import { numberFormatterInternational } from 'app/utils/telephonyHelpers';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import {
  FlowNode,
  flowNodeColor,
  InternalPortT,
  NodeT,
  NodeTypeComponent,
  RegisterPortT,
} from 'fable/flowEditor';

import { PowerCallFlowExtraDataT } from '../PowerCallFlow';
import AnnounceFromPayload from '../helpers/announceFromPayload';
import { Callback as ActionModal } from '../modals/callback';
import type { AnnouncementPayloadT } from '../types';

type Payload = {
  announcement: null | AnnouncementPayloadT;
  digit: string;
  from_number: null | string;
  next_node_id: null | string;
};

export type FlowCallNodeCallback = NodeT<FlowNodeTypes.CALLBACK, Payload>;

const portTranslator = (node: FlowCallNodeCallback): RegisterPortT[] => [
  {
    connection: node.payload.next_node_id || uuid(),
    id: uuid(),
    label: 'arrow',
    type: 'out',
  },
];

export class CallbackNode extends NodeTypeComponent<
  FlowCallNodeCallback,
  PowerCallFlowExtraDataT
>() {
  static icon: IconNames = 'callback';
  static label = 'Callback';
  static color = flowNodeColor.orange;
  static height = FlowNode.dimensions.h + 16;
  static translatePayload = formatPortsHelper(portTranslator);
  static ActionModal = ActionModal;
  static actionTrigger = { type: FlowNodeTypes.CALLBACK };
  static updateConnection = (
    node: FlowCallNodeCallback,
    _port: InternalPortT,
    newConnection: string,
  ): FlowCallNodeCallback => {
    const payload = { ...node.payload };
    payload.next_node_id = newConnection;

    return { ...node, payload };
  };

  @boundMethod
  triggerEdit(): void {
    const { onEdit, node } = this.props;
    onEdit(node, node.nodeType);
  }

  render() {
    const { extraData, node } = this.props;
    const usedNumber = node.payload?.from_number || extraData.number;
    const phoneNumber = usedNumber
      ? numberFormatterInternational({ phoneNumber: usedNumber })
      : 'No number selected';

    return (
      <FlowNode
        color={CallbackNode.color}
        icon={CallbackNode.icon}
        label={CallbackNode.label}
        text={
          <div>
            <AnnounceFromPayload node={node} extraData={extraData} />
            <div>
              Outbound number <strong>{phoneNumber}</strong>
            </div>
          </div>
        }
        onEdit={this.triggerEdit}
      />
    );
  }
}
